"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoiTypeSchema = exports.PoiType = void 0;
const zod_1 = require("zod");
/** Distinguishes independent, non-bookable info-POI categories (DocStop today; gasStation/restArea planned). */
var PoiType;
(function (PoiType) {
    PoiType["DOCTOR"] = "DOCTOR";
    PoiType["SERVICE_POINT"] = "SERVICE_POINT";
})(PoiType || (exports.PoiType = PoiType = {}));
exports.PoiTypeSchema = zod_1.z.nativeEnum(PoiType);
//# sourceMappingURL=poi-type.js.map